import React from "react"

export type QuestionContextMenuContextType = {
  markedItems: string[]
  stikethroughAnswers: string[]
  setMarkForReview?: () => void
  setStikethrough?: (answerId: string) => () => void
}

export const QuestionContextMenuContext =
  React.createContext<QuestionContextMenuContextType | null>(null)
